import { Pipe, PipeTransform } from '@angular/core';
import {
  ComponentSwitcherConfig,
  ComponentSwitcherConfigOptions,
} from '@nx-massaud/component-switcher';
import { DrupalIdentifier } from '@madeinlune/drupal-types';

@Pipe({
  name: 'componentSwitcher',
  standalone: true,
})
export class ComponentSwitcherPipe implements PipeTransform {
  transform(
    data: DrupalIdentifier,
    options?: ComponentSwitcherConfigOptions
  ): ComponentSwitcherConfig {
    if (options?.['template'] === 'project-banner') {
      return {
        data,
        component: () =>
          import('@nx-massaud/ui/project-banner').then(
            (m) => m.ProjectBannerComponent
          ),
      };
    }
    return {
      data,
      component: () =>
        import('@nx-massaud/ui/grid-list-item').then(
          (m) => m.GridListItemComponent
        ),
    };
  }
}
